import ChargePricesPage from "./pages/ChangePricesPage";
import ChargeTypesPage from "./pages/ChargeTypesPage";
import MyInvoicesPage from "./pages/invoice/MyInvoicesPage";
import InvoicePage from "./pages/invoice/InvoicePage";
import PaymentSuccess from "./pages/invoice/PaymentSuccess";
import PaymentFailed from "./pages/invoice/PaymentFailed";
import ReceiptView from "./pages/invoice/ReceiptView";

import MyDuesPage from "./pages/MyDuesPage";
import UserDuesPage from "./pages/UserDuesPage";
import UserPaymentsPage from "./pages/UserPaymentsPage";
import FinancialStatusPage from "./pages/FinancialStatusPage";
import MyReceiptsPage from "./pages/MyReceiptPage";
import AdminRecordPaymentPage from "./pages/AdminRecordPaymentPage";
import DuesAnalysisPage from "./pages/DuesAnalysisPage";
import FinanceDashboard from "./pages/FinanceDashboard";
import FinanceAnalyticsPage from "./pages/FinanceAnalyticsPage";
import PaymentProcessingPage from "./pages/invoice/PaymentProcessingPage";
import ReceiptPage from "./pages/invoice/ReceiptPage";
import MyPayments from "./pages/invoice/MyPayments";
import AdminUserInvoicePage from "./pages/invoice/AdminUserInvoicePage";
import FinanceManagement from "./pages/FinanceManagement";
import DemandNotePage from "./pages/DemandNotePage";
import PaymentEditRequestsPage from "./pages/PaymentEditRequestsPage";

export const billingsRoutes = [
  {
    path: "/admin/billing/charge-types",
    element: <ChargeTypesPage />,
    roles: ["admin"],
  },

  {
    path: "/admin/billing/charge-prices",
    element: <ChargePricesPage />,
    roles: ["admin"],
  },
  {
    path: "/admin/billing/users/:userId/dues",
    element: <UserDuesPage />,
    roles: ["admin"],
  },
  {
    path: "/admin/billing/users/:userId/record-payment",
    element: <AdminRecordPaymentPage />,
    roles: ["admin"],
  },
  {
    path: "/admin/billing/users/:userId/payments",
    element: <UserPaymentsPage />,
    roles: ["admin"],
  },
  { path: "/billing/my-dues", element: <MyDuesPage /> },
  {
    path: "/my-invoices",
    element: <MyInvoicesPage />,
  },

  {
    path: "/finance/summary",
    element: <FinancialStatusPage />,
  },
  {
    path: "/finance/receipts",
    element: <MyReceiptsPage />,
  },
  {
    path: "/invoice/:id",
    element: <InvoicePage />,
  },
  {
    path: "/admin/users/:userId/invoice/:invoiceId",
    element: <AdminUserInvoicePage />,
    roles: ["admin"],
  },
  // https://niqs.org.ng/onlinepayments/subscription_pay.php?MerchantTransactionID=0000002132603220920077925
  {
    path: "/payment/processing/:type/:id",
    element: <PaymentProcessingPage />,
  },
  {
    path: "/payment/success/:paymentId",
    element: <PaymentSuccess />,
  },

  {
    path: "/receipt/:paymentId",
    element: <ReceiptPage />,
  },
  {
    path: "/payment/my",
    element: <MyPayments />,
  },
  {
    path: "/payment/failed/:invoiceId",
    element: <PaymentFailed />,
  },
  {
    // The route carried NO gate at all, and RequirePermission lets an
    // unrestricted route through for any signed-in user — so every member's
    // billing position was one typed URL away from any student or probationer.
    path: "/dues/analysis",
    element: <DuesAnalysisPage />,
    perms: ["dues.analysis.access"],
  },
  {
    path: "/finance/analysis",
    element: <FinanceManagement />,
  },
  {
    // Gated on the privilege, not the admin role, so the sidebar link and the
    // route agree — otherwise a holder sees the link and is bounced to
    // /unauthorized by it.
    path: "/admin/billing/demand-note",
    element: <DemandNotePage />,
    perms: ["billing.demand_note.access"],
  },
  {
    // Matches what the API already enforces on /payment-edit-requests.
    path: "/finance/payment-requests",
    element: <PaymentEditRequestsPage />,
    perms: ["billing.amendment.access"],
  },
];
